import { isAxiosError } from "axios";
import { LoaderFunction, Navigate, Outlet, redirect, useRouteError } from "react-router-dom";

import { getPlatformCurrent, getUser } from "api/methods";
import { isAnonymousBrowsing } from "modules/anonymousBrowsing";
import { queryClient } from "pages/Root";
import RootError from "pages/RootError";
import { clearAcknowledgedPopupPromotionIds } from "utils/functions";
import { isNativeMobileApp } from "utils/platform.helpers";

export const authenticatedOnboardingLoader: LoaderFunction = async ({ request }) => {
  if (isAnonymousBrowsing()) return redirect("/signin");

  try {
    const user = await queryClient.fetchQuery({
      ...getUser.keyed(),
      staleTime: 0,
    });

    const platform = await queryClient.fetchQuery({
      ...getPlatformCurrent.keyed(),
      queryFn: () => getPlatformCurrent().catch(() => null),
    });

    if (platform?.active === false) {
      if ((isNativeMobileApp() && !request.url.includes("/signin")) || !isNativeMobileApp()) {
        return redirect("/deactivated");
      }
    }

    return user;
  } catch (error) {
    if (isAxiosError(error) && error.response?.status === 401) {
      clearAcknowledgedPopupPromotionIds();
      return redirect("/signin");
    }
    throw error;
  }
};

const AuthenticatedOnboardingLayout = () => {
  return (
    <div className="flex flex-auto">
      <div className="w-full">
        <Outlet />
      </div>
    </div>
  );
};

export const AuthenticatedOnboardingLayoutError = () => {
  const error = useRouteError();

  if (isAxiosError(error) && error.response?.status === 401) {
    clearAcknowledgedPopupPromotionIds();
    return <Navigate to="/signin" />;
  }

  return <RootError />;
};

export default AuthenticatedOnboardingLayout;
